import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'
import { client } from '@/proxy/client'

export const ACTIVE_ORDERS = gql`
  query sellerActiveOrders {
    activeOrders {
      number
      date
      checkoutType
      customer {
        name
        email
        isFirstPurchase
      }
      items {
        name
        amount
        unitPrice
        variantId
        totalPrice
        image
        categoryId
        brandId
      }
      delivery {
        address {
          street
          complement
          province
          neighborhood
          city
          location {
            coordinates
          }
        }
        courier {
          email
        }
        code
        type
        deliveryDate {
          startDate
          endDate
        }
      }
      status
      note
      isEditable
      isOrderUpdatedBySeller
      totalPrice
      expiringTime
      elapsedTime
      charging {
        coupon {
          total
          code
          description
        }
        subTotal
        discount
        cashback
        change
        shippingFee
        total
        totalSamplingsPrice
      }
      note
      payment {
        type
      }
      serviceFee {
        isHeavyBag
        total
      }
    }
  }
`

export const ACTIVE_ORDERS_QUERY_KEY = 'useActiveOrders'

export const useActiveOrders = options =>
  useQuery({
    queryKey: [ACTIVE_ORDERS_QUERY_KEY],
    queryFn: variables => client.request(ACTIVE_ORDERS, variables),
    ...options,
  })
